import { bffServiceClient } from '../../packages/request/clients';
import { getResult } from 'helpers/request';
import {
  IIssueTypeParams,
  IIssueTypeResult,
  IIssueTypeInProgressReponse,
} from 'interfaces';

const getIssueType = (params: IIssueTypeParams): Promise<IIssueTypeResult> => {
  return bffServiceClient.get('/issueType', { params }).then(getResult);
};

const getIssueTypeInProgressByUser = (): Promise<IIssueTypeInProgressReponse> => {
  return bffServiceClient.get('/issueType/inProgressByUser').then(getResult);
};

export default { getIssueType, getIssueTypeInProgressByUser };
